import React, { useCallback, useLayoutEffect, useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import './NotFound.css'; // ide tesszük az animációkat
import { useLoading } from '../LoadingContext';
import { saveLocale, getLocale } from '../transInit';
import { t } from 'ttag';


const NotFound = () => {
    const { toggleLoading } = useLoading();
    const [themeReady, setThemeReady] = useState([]);

    useEffect(() => {
        if (themeReady) {
            const timer = setTimeout(() => {
                toggleLoading(false);
            }, 1000); // 1000ms = 1 second

            return () => clearTimeout(timer); // cleanup
        }
    }, [themeReady]);

    useLayoutEffect(() => {
        //const header = document.getElementById('headerLogo');
        //toggleLoading(true);

        document.body.classList.add("dark-theme");
        document.body.style.setProperty("--elsodleges-szin", "#00000000");
        document.body.classList.add("basic-navbar");
        document.body.classList.add("feher-logo-header");
        
        //if(header && header.classList) {header.classList.add("feher-logo")}
        
        setThemeReady(true);

        // Cleanup (opcionális, ha eltávolítanád a class-t amikor a komponens unmountolódik)
        return () => {
            document.body.classList.remove("dark-theme");
            document.body.classList.remove("basic-navbar");
            document.body.classList.remove("feher-logo-header");
        };
    }, []);

    return (
        <Container className="text-center py-5 mb-4">
            <Row className="justify-content-center">
                <Col md="8">
                    <div style={{ maxWidth: '300px', margin: '0 auto' }}>
                        <PopcornSVG />
                    </div>
                    <h1 className="display-4">404</h1>
                    <p className="lead">
                        {t`A keresett oldal nem található.`}
                    </p>
                </Col>
            </Row>
        </Container>
    );
};



const PopcornSVG = () => (
    <svg
        viewBox="0 0 200 300"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '60%', height: 'auto' }}
    >
        {/* Árnyék a földön */}
        <ellipse cx="100" cy="280" rx="60" ry="10" fill="#000" opacity="0.1" />

        {/* Zacskó alja (ferde, 3D hatás) */}
        <polygon points="60,260 140,260 160,100 40,100" fill="#ff4f4f" stroke="#c0392b" strokeWidth="2" />

        {/* Fehér csíkok */}
        <polygon points="60,260 72,100 88,100 76,260" fill="#fff" opacity="0.9" />
        <polygon points="92,260 104,100 120,100 108,260" fill="#fff" opacity="0.9" />

        {/* Fehér ovális „Pop Corn” felirattal */}
        <g>
            <ellipse cx="100" cy="180" rx="40" ry="20" fill="#ffffff" stroke="#c0392b" strokeWidth="2" />
            <text x="100" y="185" textAnchor="middle" fill="#c0392b" fontSize="12" fontFamily="Arial" fontWeight="bold">
                PopCorn
            </text>
        </g>

        {/* Popcorn halom */}
        <g>
            {/* Alsó réteg */}
            <circle cx="50" cy="100" r="15" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="70" cy="95" r="16" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="90" cy="92" r="17" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="110" cy="94" r="16" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="130" cy="98" r="15" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="150" cy="102" r="14" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />

            {/* Középső réteg */}
            <circle cx="60" cy="85" r="14" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="80" cy="80" r="15" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="100" cy="78" r="17" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="120" cy="82" r="15" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="140" cy="86" r="14" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />

            {/* Felső réteg */}
            <circle cx="70" cy="65" r="12" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="90" cy="60" r="13" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="110" cy="62" r="13" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
            <circle cx="130" cy="68" r="12" fill="#fff3b0" stroke="#e1c870" strokeWidth="1" />
        </g>
    </svg>

);

export default NotFound;



